
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
// import { RiskMapReportType } from '@/shared/types'
import { ERiskMapCard } from '@/entities/ERiskMapCard'
import { riskMapReportApi } from '@/shared/api'
import {
  useOrganizationModules,
  useReportListing,
  useUser,
} from '@/shared/composables'
import { getDateDistance } from '@/shared/utils'

export default defineComponent({
  name: 'RiskMapReports',

  components: {
    ERiskMapCard,
  },

  props: {
    search: String,
  },

  setup(props) {
    const { user } = useUser()
    const { isReportListingUpdated, setUpdateReportListing } =
      useReportListing()

    const route = useRoute()
    const router = useRouter()

    // change type of ref
    const reports = ref<Object[]>([])
    const loading = ref(false)

    const patientId = computed((): string | string[] => route.params.patientId)
    const activeReportId = computed(() => Number(route.params.reportId))
    const isPreviewMode = computed(() => route.query['view-mode'] === '1')
    const { organizationModules } = useOrganizationModules()
    const isSubscriptionEnded = computed(
      () =>
        !getDateDistance(user.value.organization.block_at) ||
        organizationModules.value.indexOf('riskmap') <= -1
    )

    watch(
      () => props.search,
      () => {
        getReports()
      }
    )

    watch(patientId, (newPatientId, oldPatientId) => {
      if (newPatientId && newPatientId !== oldPatientId) {
        getReports()
      }
    })

    watch(
      () => isReportListingUpdated.value,
      (isUpdated) => {
        if (isUpdated) {
          getReports()
          setUpdateReportListing(false)
        }
      }
    )

    const getReports = async (): Promise<void> => {
      loading.value = true

      reports.value = []
      const [error, response] = await riskMapReportApi.getReports(
        Number(patientId.value)
      )

      loading.value = false
    }

    const handleOpenReportCreationPage = (): void => {
      console.log('get data for risk map report')
      let firstPatientId: string
      if (Array.isArray(patientId)) {
        firstPatientId = patientId[0]
      } else {
        // @ts-ignore
        firstPatientId = patientId
      }
      reports.value = riskMapReportApi.saveReport(firstPatientId)
      loading.value = false
      console.log('close')
      router.push({
        name: 'RiskMapPage',
        params: { patientId: patientId.value },
      })
    }

    const handleOpenReportPage = async (reportId: number): Promise<void> => {
      router.push({
        name: 'RiskMapPage',
        params: { patientId: patientId.value, reportId },
      })
    }

    onMounted((): void => {
      getReports()
    })

    return {
      reports,
      loading,
      activeReportId,
      isPreviewMode,
      isSubscriptionEnded,
      handleOpenReportCreationPage,
      handleOpenReportPage,
    }
  },
})
